import { Theme, } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      marginRight: '24px',
    },
    appBar: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black
    },
    menu: {
      flex: 1,
    },
    menuItem: {
      padding: theme.spacing(2, 3),
      color: theme.palette.common.black,
      paddingLeft: '13px',
      paddingRight: '13px',
    },
    activeMenuItem: {
      color: theme.palette.primary.main
    },
  }
});

export default useStyles;
